const detailsCategories = {
  // favoriteCategories : {
  //     name: 'Favourite Categories',
  //     categories: [
  //         {id: 1, name:'Basic Information'},
  //         {id: 2, name:'Guest Rooms'}
  //     ]
  // },
  propertyCategories: {
      name: 'Property Categories',
      categories: [
        {id: 1, name:'Basic Information'},
        {id: 2, name:'Guest Rooms'},
        {id: 3, name:'Affiliations'},
        {id: 4, name:'Amenities and Services'},
        {id: 5, name:'Attractions'},
        {id: 6, name:'Environmental Impact'},
        {id: 7, name:'GDS Information'},
        {id: 8, name:'Policies'},
        {id: 9, name:'Meeting Facilities'},
        {id: 10, name:'Nearby Hotels'},
        {id: 11, name:'Images'},
        // {id: 12, name:'Promotions'}, // CNT-1678
        {id: 13, name:'Rate Plans'},
        {id: 14, name:'Recreation'},
        {id: 15, name:'Reference Points'},
        // {id: 17, name:'Viewership'},
        {id: 18, name:'Communications'},
        {id: 19, name:'Reservation Information'},
        {id: 21, name:'Contact Person'},
        {id: 22, name:'Dining Options'},
        {id: 23, name:'Other Distribution Systems'},
        {id: 24, name:'Other Amenity Info'},
        {id: 25, name:'Other Payments'},
        { id: 26, name: 'Ownership' },
        /* {id: 27, name:'Custom'}, */
      ]
  }
}

const categorieTabs:{
  [key: number]: { categorieID: number, tabs: Array<any> };
}  = {
  1: {categorieID:1, tabs: [
      {id: 1, name: 'General'},
      {id: 2, name: 'Descriptions'},
      {id: 3, name: 'Contacts'},
      {id: 4, name: 'Capacities'},
      {id: 5, name: 'Classifications'},
      {id: 6, name: 'Closures'},
  ]},
  2: {categorieID:2, tabs: [
      {id: 4, name: 'tab4'},
      {id: 5, name: 'tab5'},
      {id: 6, name: 'tab6'},
      {id: 7, name: 'tab7'},
      {id: 8, name: 'tab8'},
  ]},
  24: {categorieID:24, tabs: [
    {id: 1, name: 'Other Amenity Info'},
    {id: 2, name: 'Extra Accessible Feature & Security'},
    {id: 3, name: 'Hotel Closure'},
    {id: 4, name: 'General Room Amenity'},
]}
}

export {
  detailsCategories,
  categorieTabs
}
